import { z } from 'zod'
import { ApiValidationError, HttpError } from './error'

export const httpErrorSchema = z.object({
  error: z.object({
    message: z.string(),
    status: z.number(),
    statusText: z.string(),
    url: z.string(),
    method: z.string(),
    responseData: z.any()
  }),
  requestInfo: z.object({
    url: z.string(),
    requestOptions: z.object({
      method: z.union([
        z.literal('GET'),
        z.literal('POST'),
        z.literal('PUT'),
        z.literal('PATCH'),
        z.literal('DELETE')
      ]),
      body: z.any().optional(),
      query: z.any().optional()
    })
  })
})

export type HttpErrorType = z.infer<typeof httpErrorSchema>

export function apiErrorHandler(
  error: unknown,
  requestInfo: HttpErrorType['requestInfo']
) {
  if (error instanceof ApiValidationError) {
    const { errorData } = error

    console.error({
      source: 'zod',
      type: 'error',
      data: {
        data: JSON.parse(JSON.stringify(errorData)),
        issues: JSON.parse(JSON.stringify(errorData.result.error.issues))
      }
    })

    return Promise.reject(errorData)
  }

  if (error instanceof HttpError) {
    console.error(
      error.message,
      `\nStatus:${error.status}`,
      `\nStatusText：${error.statusText}`
    )

    return Promise.reject({ error, requestInfo } satisfies HttpErrorType)
  }

  if (error instanceof Error) {
    console.error(
      '系統發生錯誤',
      error.message,
      JSON.parse(JSON.stringify(error.cause)),
      '\n\n\n'
    )

    return Promise.reject(error)
  }

  return Promise.reject(error)
}
